import { restApiFP } from "@plannel/services/utils/rest-api";
import fpApiUtil from "./fp-api-util";

// FP 공용 조회(lookup) 서비스 — 여러 화면이 공유하는 조직/코드 트리, 공통코드 등.

// 계획수립일 목록(버전이 존재하는 날짜) — VersionSearchGroup(Report 전 화면 공용 컴포넌트) 캐스케이드
// 1단계. old VersionSearchGroup.jsx의 setPlanDt (factoryplan/versions/plan-dts). params: { planScope }.
const getPlanDts = (params) => fpApiUtil.postParams("factoryplan/versions/plan-dts", params);

// 계획수립일(+planScope) 기준 버전 목록 — 캐스케이드 2단계.
// old VersionSearchGroup.jsx의 getVersionList (factoryplan/versions). params: { planScope, planningDate }.
const getVersions = (params) => fpApiUtil.postParams("factoryplan/versions", params);

const getStagesTree = (params) => fpApiUtil.postParams("factoryplan/stages-tree", params);
// 인벤토리(+품목/공장/스테이지 조인) 목록 — InventoryPopup 등 공용 조회.
// CommonController POST /factoryplan/inventories (itemService.getInventories).
const getInventories = (params) => fpApiUtil.postParams("factoryplan/inventories", params);
// 작업 주문 목록 — WorkOrderPopup 등 공용 조회. CommonController POST /factoryplan/work-orders.
const getWorkOrders = (params) => fpApiUtil.postParams("factoryplan/work-orders", params);
// BOR(공정-설비) 목록 — WipLocationPopup 등 공용 조회. CommonController POST /factoryplan/bors.
const getBors = (params) => fpApiUtil.postParams("factoryplan/bors", params);
// 계획 단계(시뮬레이션 절차) 목록 — CommonController POST /factoryplan/plan-steps
// (planningService.getPlanSteps). params: { viewId, subId, planScope }.
const getPlanSteps = (params) => fpApiUtil.postParams("factoryplan/plan-steps", params);
// 계획 정책(시나리오) 목록 — CommonController POST /factoryplan/plan-policy
// (planningService.getPlanPolicies). PlanPolicyDto의 defaultYn이 기본 시나리오 표시다.
const getPlanPolicies = (params) => fpApiUtil.postParams("factoryplan/plan-policy", params);
// 계획 정책 상세(수립 전략 + 규칙 선택·순서) — CommonController POST /factoryplan/plan-policy-detail.
// params: { viewId, subId, planScope, policyCd }. 서버 정렬(orderBy categoryCd, itemSeq —
// 2026-08-10 old와 동일하게 복원됨)과 별개로, 호출부는 itemSeq 정렬을 방어적으로 유지한다.
const getPlanPolicyDetails = (params) => fpApiUtil.postParams("factoryplan/plan-policy-detail", params);
// 스테이지 CUD (organizationService.persistStages). changes로 StageDto 전송.
const saveStages = (changes) => fpApiUtil.postChanges("factoryplan/stages/save", changes);
const removeStages = (changes) => fpApiUtil.postChanges("factoryplan/stages/delete", changes);

// 공통 코드 그룹의 코드 목록. CodeController(GET /common/codes?code-group-cd=..., JSON 응답).
const getCodes = (codeGroupCd) =>
  restApiFP.get("common/codes", { params: { "code-group-cd": codeGroupCd } });

// 공정이 생산하는 품목 목록(BOM 기준, bomTpCd='P'). CommonController#getProducingRoutes
// (POST /factoryplan/producingroutes) — RoutePopup.js가 두 모드 모두에서 사용(routeCd=""면 전량,
// 지정하면 그 공정만 — old도 type과 무관하게 항상 이 하나의 엔드포인트만 씀).
const getProducingRoutes = (params) => fpApiUtil.postParams("factoryplan/producingroutes", params);

// 특정 자원(resourceCd)이 사용되는 BOR(공정-자원) 목록 — CommonController#getBors
// (POST /factoryplan/bors, BorQueryRepository의 resourceCd 정확일치 필터). master CRUD용
// `factoryplan/master/bor/bors`(fp-bor-service.js)와는 다른 조회 전용 엔드포인트.
// ResourceRoutePopup.js(자원 기준 공정 선택)에서 사용.
const getBorRoutes = (params) => fpApiUtil.postParams("factoryplan/bors", params);

// 자원 목록 — CommonController#getResources(POST /factoryplan/resources). params:
// { viewId, subId, planScope, resourceCdNm }. old ResourceGantt.jsx의 loadResources 대응 —
// report/ResourceGantt.js의 자원 멀티셀렉트(resourceCds) 옵션 로드용. 아래 getToolResources와
// **같은 엔드포인트**지만 isTool 필터 유무로 의미가 달라 함수를 나눠 둔다(old도 호출부가 달랐다).
const getResources = (params) => fpApiUtil.postParams("factoryplan/resources", params);

// 툴 자원 목록(isTool:true 필터) — CommonController#getResources(ResourceService#getResources,
// POST /factoryplan/resources). old ToolAvailability.jsx의 loadResources 대응 —
// report/ToolAvailability.js의 자원 멀티셀렉트(toolResourceCds) 옵션 로드용.
const getToolResources = (params) => fpApiUtil.postParams("factoryplan/resources", params);

// 특정 모듈에 매핑된 계획범위 목록(이름 포함). PlanScopeController
// (GET /common/planscope/modules/module?module-cd=FP, JSON). plan_scope와 조인돼 planScopeNm/useYn/displaySeq 포함.
// 전체 계획범위가 아니라 "그 모듈이 쓰는 범위"만 반환(예: FP는 DOMESTIC 제외). use_yn 필터는 호출부에서.
const getModulePlanScopes = (moduleCd) =>
  restApiFP.get("common/planscope/modules/module", { params: { "module-cd": moduleCd } });

const fpCommonService = { getPlanDts, getVersions, getStagesTree, getInventories, getWorkOrders, getBors, getPlanSteps, getPlanPolicies, getPlanPolicyDetails, saveStages, removeStages, getCodes, getModulePlanScopes, getProducingRoutes, getBorRoutes, getResources, getToolResources };
export default fpCommonService;
